
import InvoiceContainer from "@/components/invoice/InvoiceContainer.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { InvoiceContainer },
});
